import React from "react";
import {TerminateContractContainer} from "./styles"
import {MainLayout} from "../../layouts/MainLayout";
import {useTranslation} from "react-i18next";
import useFetchEmployees from "../../hooks/useFetchEmployees";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {capitalize, fullNameForUser} from "../../utils";
import {CONTRACT_TERMINATION_REQUESTER_COMPANY, FETCH_STATUS_IDLE, FETCH_STATUS_LOADING} from "../../utils/constants";
import {ReactComponent as DownloadIcon} from "../../assets/icons/download_icon.svg"
import {downloadDocument} from "../../services/documents";
import {
    InputFieldsWrapper,
    InputText,
    PopupLoading,
    PrimaryButton,
    TopNotification
} from "../../components";
import {
    allEmployeesFetchState,
    selectEmployeeById,
    updateEmployeeState
} from "../../app/employee/selectors";
import {selectAdminUser} from "../../app/adminUser/selectors";
import {terminateContract} from "../../app/employee/actions";


const TerminateContract = () => {

    useFetchEmployees()
    const params = useParams()
    const dispatch = useDispatch()
    const id = params.id || ''

    const employee = useSelector(selectEmployeeById(id));

    const updateStatus = useSelector(updateEmployeeState);
    const fetchState = useSelector(allEmployeesFetchState);

    const admin = useSelector(selectAdminUser);

    const {t} = useTranslation();
    const navigate = useNavigate();

    if (fetchState === FETCH_STATUS_IDLE || fetchState === FETCH_STATUS_LOADING || updateStatus === FETCH_STATUS_LOADING) {
        return <MainLayout>
            <PopupLoading isOpen={true}/>
        </MainLayout>
    }

    if(!employee){
        return navigate('/employees')
    }

    const handleSubmit = async () => {
        await dispatch(terminateContract({
            employeeId: employee._id,
            companyId: employee.company._id,
            requester: requester
        }) as any)
        navigate('/employees')
    }

    const requester = employee.contract_termination?.requester || ''

    return <MainLayout>
        <TerminateContractContainer>
            <h1>{`${capitalize(employee.activity)} - ${capitalize(fullNameForUser(employee))}`}</h1>
            <section>
                <TopNotification type='info' message={t('termination_explanation')}/>
                <h3>{t('cancellation_details')}</h3>
                <InputFieldsWrapper>
                    <InputText disabled
                       label={t('requester') as string}
                       value={t(requester) as string}
                    />
                    <InputText disabled
                               label={t('termination_date') as string}
                               value={new Date(employee?.contract_termination?.termination_date || '').toLocaleDateString(admin.locale, {day: 'numeric', month: 'long', year:'numeric'})}
                    />
                </InputFieldsWrapper>
                <InputFieldsWrapper>
                    <InputText disabled
                               label={t('has_company_assets') as string}
                               value={employee?.contract_termination?.has_company_assets || false ? t('yes') as string : t('no') as string}
                               helperText={t('needs_to_return_company_assets') as string}
                    />
                    {employee.contract_termination?.remaining_vacation_days && <InputText disabled
                                label={'Vocation days use preference'}
                                value={t(employee.contract_termination.remaining_vacation_days) as string}
                                helperText={t('vacation_days_use_preference_explanation') as string}
                    />}
                </InputFieldsWrapper>
            </section>
            <section>
                <h3>{t('detailed_reason')}</h3>
                <div className="detailed_reason">
                    {employee?.contract_termination?.reason || ''}
                </div>
            </section>
            <section>
                <h3>{requester === CONTRACT_TERMINATION_REQUESTER_COMPANY ? t('download_layoff_report') : t('download_resignation_report')}</h3>

                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="download-layoff-report" onClick={() => downloadDocument(employee?.contract_termination?.report || '', employee.company._id)}>
                    <DownloadIcon/>
                    {requester === CONTRACT_TERMINATION_REQUESTER_COMPANY ? t('download_layoff_pdf') : t('download_resignation_pdf')}
                </a>
            </section>
            <div className="terminate-contract">
                <PrimaryButton onClick={handleSubmit}>{t('terminate_contract')}</PrimaryButton>
            </div>
        </TerminateContractContainer>
    </MainLayout>
}

export default TerminateContract;
